import React from "react";
import { getValue } from "../../utils";
import { Div, Text1 } from "components/Base";
import { getFileIconAndExtension } from "Portal/NewPortal/Shared/getFileIconAndExtension";
import { Link } from "react-router";
import { eventDetails } from "redux/modules/event/selectors";
import { orgDetails } from "redux/modules/organization/selectors";
import { connect } from "react-redux";

const ICON_CONTAINER_STYLE = {
  width: "18px",
  height: "24px",
  cursor: "default",
  flexShrink: 0
};

const ICON_STYLE = {
  width: "18px",
  height: "24px"
};

const OVERFLOW_ELLIPSIS = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};

const decorate = connect(state => ({
  eventDetails: eventDetails(state),
  orgDetails: orgDetails(state)
}));

const FileUploaded = props => {
  const value = getValue(props);
  const name = value.name.split(".").shift();
  const { icon: Icon, extension } = getFileIconAndExtension(value.name);
  const path = window.location.pathname + window.location.search;

  return (
    <Div display="row.space-between.center" style={OVERFLOW_ELLIPSIS}>
      <Div style={ICON_CONTAINER_STYLE}>
        <Icon style={ICON_STYLE} />
      </Div>
      <Div ml={2} style={OVERFLOW_ELLIPSIS}>
        <Link
          to={
            props?.eventDetails?.id
              ? `/event-light/${props.eventDetails.id}/files/${props.data.id}${
                  path && path.length ? `?returnTo=${path}` : ""
                }`
              : `/org-light/${props.orgDetails.id}/files/${props.data.id}${
                  path && path.length ? `?returnTo=${path}` : ""
                }`
          }
          className="underline-on-hover"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "#494949",
            fontWeight: 600
          }}
        >
          {name}
        </Link>
        <Text1 color="#727272">
          {extension} {value.size}
        </Text1>
      </Div>
    </Div>
  );
};

export default decorate(FileUploaded);
